//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'Main',
  computed: {
    ...mapGetters('landings', ['featureEnabled']),
    component() {
      return () => import('@/components/page/partner/MainPartner')
    },
  },
}
